// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__3DIv_","initialsAvatar":"UserAvatar_initialsAvatar__35OZW","avatarSize":"UserAvatar_avatarSize__1wu0J"};